import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { Stack, Tooltip, Typography } from '@mui/material'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded'

import colors from '@/assets/scss/_themes-vars.module.scss'

const NETWORK_SPEED_THRESHOLD = 2 // mbps

export type NetworkSpeedProps = {
  downloadSpeed: number | null
  uploadSpeed: number | null
}

export function NetworkSpeed(props: NetworkSpeedProps) {
  const { downloadSpeed, uploadSpeed } = props
  const { t } = useTranslation()

  return (
    <>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={{ xs: 0, md: 1 }}>
        <CloudDownloadOutlinedIcon fontSize="small" />
        <Tooltip title={t('header.networkSpeed.download.tooltip')}>
          <Typography
            sx={[
              { display: 'flex', alignItems: 'center', fontSize: '14px' },
              !_.isNull(downloadSpeed) &&
              downloadSpeed < NETWORK_SPEED_THRESHOLD && {
                color: colors.red500,
              },
            ]}
          >
            {!_.isNull(downloadSpeed) && downloadSpeed < NETWORK_SPEED_THRESHOLD && <PriorityHighRoundedIcon fontSize="small" />}
            {downloadSpeed !== null ? downloadSpeed : '-'} mbps
          </Typography>
        </Tooltip>
      </Stack>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={{ xs: 0, md: 1 }}>
        <CloudUploadOutlinedIcon fontSize="small" />
        <Tooltip title={t('header.networkSpeed.upload.tooltip')}>
          <Typography
            sx={[
              { display: 'flex', alignItems: 'center', fontSize: '14px' },
              !_.isNull(uploadSpeed) &&
              uploadSpeed < NETWORK_SPEED_THRESHOLD && {
                color: colors.red500,
              },
            ]}
          >
            {!_.isNull(uploadSpeed) && uploadSpeed < NETWORK_SPEED_THRESHOLD && <PriorityHighRoundedIcon fontSize="small" />}
            {uploadSpeed !== null ? uploadSpeed : '-'} mbps
          </Typography>
        </Tooltip>
      </Stack>
    </>
  )
}

export default NetworkSpeed
